exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.p-borrow[data-v-f72be082] {\n  height: 100%;\n  overflow: hidden;\n  background: #f0f0f0;\n}\n.p-borrow .borrow__container[data-v-f72be082] {\n  padding-top: 0.266667rem /* 20/75 */;\n}\n.p-borrow .card__outer .c-card:last-child .card__border[data-v-f72be082] {\n  display: none;\n}\n", ""]);

// exports
